//                             __
//    ____ _____  ____  ____ _/ /__     ____ ___  ____ _____  _____
//   / __ `/ __ \/ __ \/ __ `/ / _ \   / __ `__ \/ __ `/ __ \/ ___/
//  / /_/ / /_/ / /_/ / /_/ / /  __/  / / / / / / /_/ / /_/ (__  )
//  \__, /\____/\____/\__, /_/\___/  /_/ /_/ /_/\__,_/ .___/____/
// /____/            /____/                         /_/

/* global google, siteVars, appMapsData */

const loadGoogleMaps = () => {
  let js;
  let fjs;
  const id = 'google-maps-api';

  console.log('{ loadGoogleMaps }');
  // console.log('document.getElementById( id ): %o', document.getElementById(id));

  if (document.getElementById(id)) {
    window.makeGoogleMaps();
    return;
  }

  // lg = document.documentElement.getAttribute( 'lang' );
  fjs = document.getElementsByTagName('script')[0];
  js = document.createElement('script');
  js.id = id;
  js.src =
    '//maps.googleapis.com/maps/api/js?callback=makeGoogleMaps&key=' +
    siteVars.maps_key;
  js.setAttribute('async', '');
  js.setAttribute('defer', '');
  fjs.parentNode.insertBefore(js, fjs);
};

// ----------------------------------------------------------------------------
//
// Make Google Maps
//
// ----------------------------------------------------------------------------
window.makeGoogleMaps = function() {
  console.log('{ window.makeGoogleMaps }');
  // Use snazzymaps https://snazzymaps.com for 'styles'
  // https://developers.google.com/maps/documentation/javascript/get-api-key
  const markerIcon = siteVars.assetsPath + 'images/icon-map-marker.png';
  const mapStyles = [
    {
      featureType: 'administrative',
      elementType: 'geometry',
      stylers: [
        {
          color: '#a7a7a7'
        }
      ]
    },
    {
      featureType: 'administrative',
      elementType: 'labels.text.fill',
      stylers: [
        {
          visibility: 'on'
        },
        {
          color: '#737373'
        }
      ]
    },
    {
      featureType: 'landscape',
      elementType: 'geometry.fill',
      stylers: [
        {
          visibility: 'on'
        },
        {
          color: '#ffffff'
        }
      ]
    },
    {
      featureType: 'landscape.natural.landcover',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffffff'
        }
      ]
    },
    {
      featureType: 'landscape.natural.terrain',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffffff'
        }
      ]
    },
    {
      featureType: 'poi',
      elementType: 'geometry.fill',
      stylers: [
        {
          visibility: 'on'
        },
        {
          color: '#dadada'
        }
      ]
    },
    {
      featureType: 'poi',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'poi',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#696969'
        }
      ]
    },
    {
      featureType: 'road',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffffff'
        }
      ]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [
        {
          visibility: 'on'
        },
        {
          color: '#e54360'
        }
      ]
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#e54360'
        },
        {
          lightness: '83'
        }
      ]
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#d6d6d6'
        }
      ]
    },
    {
      featureType: 'road.local',
      elementType: 'geometry.fill',
      stylers: [
        {
          visibility: 'on'
        },
        {
          color: '#e54360'
        },
        {
          weight: 1.8
        },
        {
          lightness: '89'
        }
      ]
    },
    {
      featureType: 'road.local',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#d7d7d7'
        }
      ]
    },
    {
      featureType: 'transit',
      elementType: 'all',
      stylers: [
        {
          color: '#808080'
        },
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'water',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '##000000'
        }
      ]
    }
  ];
  let mapOptions;
  let map;
  // let marker;
  let styledMapType;
  let latLngMarker;
  let latLngCenter;
  let direction;
  const zoom = 13;
  let offset = 0;

  // ----------------------------------------------------------------------------
  // loop through all map setups required
  // ----------------------------------------------------------------------------
  $.each(Object.keys(appMapsData), i => {
    console.log('{ makeGoogleMaps }');

    // Outputs -1 or +1
    direction = (i % 2) * 2 - 1;

    if (!siteVars.mobile) {
      offset = direction * 0.065;
      // zoomFactor = zoom * 0.65;
    }

    latLngMarker = new google.maps.LatLng(
      appMapsData[i]['long'],
      appMapsData[i]['lat']
    );
    latLngCenter = new google.maps.LatLng(
      appMapsData[i]['long'],
      Number(appMapsData[i]['lat']) + offset
    );

    mapOptions = {
      mapTypeControlOptions: {
        mapTypeIds: ['']
      },
      center: latLngCenter,
      zoom: zoom,
      disableDefaultUI: true,
      mapTypeId: 'sage',
      scrollwheel: false,
      draggable: true
    };

    map = new google.maps.Map($('.acf-map-' + i)[0], mapOptions);

    styledMapType = new google.maps.StyledMapType(mapStyles, { name: 'sage' });

    map.mapTypes.set('sage', styledMapType);

    // --------------------------------------------------------------------------------
    // Creating a marker and positioning it on the map
    // --------------------------------------------------------------------------------
    /* eslint-disable */
    const marker = new google.maps.Marker({
      position: latLngMarker,
      map: map,
      icon: markerIcon
    });
    /* eslint-enable */
  });
};

export { loadGoogleMaps };



// WEBPACK FOOTER //
// ./scripts/modules/maps.js